<template>
  <BaseDialog :isOpen="isOpen" :sending="sending" :confirmText="confirmText"
    :closeText="closeText" :color="color"
    @close="$emit('close')" @confirm="$emit('submit-form')">

    <DialogTitle as="h3"
      class="text-[17px] font-bold text-foreground tracking-tight mb-2">
      {{ title }}
    </DialogTitle>

    <div class="mb-5">
      <p class="text-[14px] leading-relaxed text-muted-foreground">
        <slot />
      </p>
    </div>

  </BaseDialog>
</template>

<script setup lang="ts">
import { DialogTitle } from '@headlessui/vue';
import BaseDialog, { type DialogColor } from './BaseDialog.vue';

withDefaults(defineProps<{
  title: string;
  confirmText: string;
  closeText: string;
  isOpen: boolean;
  sending: boolean;
  name?: string;
  color?: DialogColor;
}>(), {
  isOpen: false,
  sending: false,
  color: 'primary',
});

defineEmits<{
  (e: 'close'): void;
  (e: 'submit-form'): void;
  (e: 'open'): void;
}>();
</script>
